import { Routes, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import MentionsLegales from "./Pages/MentionsLegales/MentionsLegales";
import PolitiqueConfidentialite from "./Pages/PolitiqueConfidentialite/PolitiqueConfidentialite";



export default function Routing() {
    return (
        <Routes>
            <Route path="/" element={<Home />}/>
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />

            
        </Routes>
    )
}   